// extracted by mini-css-extract-plugin
module.exports = {"container":"vi-z","heading":"wi-z","links":"xi-z","linkBtn":"yi-z","disabled":"zi-z","linkUppercaseBold":"Ai-z","copy":"Bi-z","subCopy":"Ci-z"};